import { render, staticRenderFns } from "./basePage.vue?vue&type=template&id=076c0903"
import script from "./basePage.vue?vue&type=script&lang=js"
export * from "./basePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('076c0903')) {
      api.createRecord('076c0903', component.options)
    } else {
      api.reload('076c0903', component.options)
    }
    module.hot.accept("./basePage.vue?vue&type=template&id=076c0903", function () {
      api.rerender('076c0903', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sample/component/basePage.vue"
export default component.exports